import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { EntityCalendarQueryData, EntityCalendarQueryType } from 'globals/store/public.model';
import { downloadFromBlob } from 'src/app/helpers/helpers';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { MatDialog } from '@angular/material/dialog';
import { CalendarSubscriptionDialogComponent, CalSubscriptionData } from 'src/app/modules/share/share.calendar.subscribe.dialog';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { LoaderComponent } from '../loader/loader.component';

@Component({
    selector: 'add-to-cal',
    template: `
  <div class="add_to_cal_btn" [ngClass]="{ buttonView: buttonView }">
    <div (click)="subscribeToCal($event)" *ngIf="canSubscribe">
      <icon *ngIf="!buildingIcs" icon="calendar"></icon> 
      <loader *ngIf="buildingIcs" icon="BUTTON_WHEEL_GREY">loading....</loader>
      <div class="link">Subscribe to calendar &rsaquo;</div>
    </div>
    <div (click)="mockOnly ? mockUser() : addToCal($event)" *ngIf="!canSubscribe">
      <icon *ngIf="!buildingIcs" icon="calendar"></icon> 
      <loader *ngIf="buildingIcs" icon="BUTTON_WHEEL_GREY">loading....</loader>
      <div class="link">Add to calendar &rsaquo;</div>
    </div>
  </div>
`,
    styles: [`
  .add_to_cal_btn { font-size: 14px; display: flex; align-items: center; text-transform: none; font-weight: normal; cursor: pointer; min-width: 175px; color: var(--link); }
  .add_to_cal_btn.buttonView { border-radius: 4px; background: #DDE5EC; padding: 5px; }
  .add_to_cal_btn  loader { width: 24px; }
  .add-text { margin-left: 5px; }
  .add_to_cal_btn > div { display: flex; align-items: center; }
  .link:hover { text-decoration: underline; }
  `],
    standalone: true,
    imports: [CommonModule, IconComponent, LoaderComponent],
})
export class AddToCalComponent implements OnInit{

  @Input() addText = "Add to calendar›"
  @Input() title: string;
  @Input() eventId: string;
  @Input() entityId: string
  @Input() entityType: EntityCalendarQueryType
  @Input() shareCode: string
  @Input() mockOnly = false
  @Input() canSubscribe = false;
  @Input() buttonView = false
  @Input() notPublished = false
  @Input() notPublishedMessage = ''
  buildingIcs
  readonly api = `${environment.functionsURL}api/app`;
  readonly v1 = `${environment.functionsURL}api/v1`;


  constructor(
    private http: HttpClient,
    private dialog: MatDialog
  ){}
  ngOnInit(){

  }

  mockUser() {
    console.log("You haven't implemented this.  Neener neener neener!")
  }

  subscribeToCal(event){
    event.stopPropagation()
    const rect = (<HTMLElement>event.target).getBoundingClientRect()
    const data: CalSubscriptionData = {
      x: rect.left,
      y: rect.top + 20,
      title: 'Cal sub title',
      notPublishedMessage: this.notPublished ? this.notPublishedMessage : '',
      shareCode: this.shareCode,
      entityId: this.entityId,
      entityType: this.entityType,
      eventId: this.eventId
    }
    openDialogGetResult<string>(this.dialog, CalendarSubscriptionDialogComponent, { width: '450px', autoFocus: false, data })
    
  }

  async addToCal(event){
    event.stopPropagation()
    if(this.buildingIcs) return;
    this.buildingIcs = true;
    const blob = await this.downloadCal(); 
    if(blob['response'] && blob['response'] === 'No event date'){
      this.buildingIcs = false;
    }
    downloadFromBlob(blob, this.title + '.ics')
    this.buildingIcs = false;
  }

  async downloadCal(){
    if(this.entityId){
      const queryData: EntityCalendarQueryData = {
        entityType: this.entityType,
        id: this.entityId,
        eventId: this.eventId,
        shareCode: this.shareCode,
      }
      return await this.http.post<Blob>(this.v1+'/add-to-calendar-v1', queryData, {responseType: 'blob' as 'json'}).toPromise()/* .catch(e=>{ <== can't do this, this returns void, not a promise.  need to wrap everything in a try / catch either here or in the calling component if you want error handling
        console.error(e)
        this.buildingIcs = false;
      }); */
    }
    return await this.http.post<Blob>(this.api+'/add-to-calendar',{eventId:this.eventId}, {responseType: 'blob' as 'json'}).toPromise();
  }
}